<app-modal>
    <form class="form">
        <div class="form_group">
            <label class="row inp_group row_ai_center">
                <div class="col-7 lbl lbl_mb_0">Сумма</div>
                <div class="col-17"><input [(ngModel)]="paymentForm.amount" name="amount" type="number" class="inp"
                        placeholder="Введите сумму"></div>
            </label>
            <label class="row inp_group row_ai_center">
                <div class="col-7 lbl lbl_mb_0">Валюта</div>
                <div class="col-17">
                    <select [(ngModel)]="paymentForm.currency" name="currency" class="inp">
                        <option value="usd">$</option>
                        <option value="eur">€</option>
                    </select>
                </div>
            </label>
        </div>
        <div class="btns_container row fw_500 fz_s">
            <button (click)="closeModal()" class="btn btn_cancel">Отмена</button>
            <button (click)="pay()" type="submit" [disabled]="isLoadingSend" class="btn dark_btn row"><span *ngIf="isLoadingSend" class="loader"></span> <span *ngIf="!isLoadingSend">Оплатить</span> </button>
        </div>
    </form>
</app-modal>